import { IResourceComponentsProps, useExport } from '@pankod/refine-core'
import { PaperRequestTable } from 'components/paperrequests'
import React, { useEffect, useState } from 'react'
export const TestEventWorkRequestList: React.FC<IResourceComponentsProps> = () => {
  return <PaperRequestTable request={{}} />
}
